export const DETAIL_BON_EXPEDITION = {
  title: 'Détail bon d\'expédition',
  dateExpedition: 'Date d\'expédition',
  adresseExpedition: 'Adresse d\'expédition',
  nomDestination: 'Nom du destinataire',
  nombreElementColis: 'Nombre d\'élément du colis',
  poidsParColis: 'Poids par colis (kg)',
  lienTracking: 'Lien de tracking',
  breadcrumb: {
    detail: 'Détail bon d\'expédition',
    liste: 'Liste des bons d\'expédition',
  },
  table: {
    code: 'Code OT',
    type: 'Type',
    etat: 'Etat',
    codePostal: 'Code postal',
    adresse: 'Adresse',
    ville: 'Ville',
  },
};

export const EDIT_BON_EXPEDITION = {
  title: 'Modifier le bon d\'expédition',
  dateExpedition: 'Date d\'expédition',
  adresseExpedition: 'Adresse d\'expédition',
  nomDestination: 'Nom du destinataire',
  nombreElementColis: 'Nombre d\'élément du colis',
  poidsParColis: 'Poids par colis (kg)',
  breadcrumb: {
    edit: 'Modifier le bon d\'expédition',
    liste: 'Liste des bons d\'expédition',
  },
};

export const LIST_BON_EXPEDITION = {
  title: 'Liste des bons d\'expédition',
  table: {
    dateExpedition: 'Date d\'expédition',
    adresseExpedition: 'Adresse d\'expédition',
    nomDestination: 'Nom du destinataire',
    nombreElementColis: 'Nombre d\'élément du colis',
    poidsParColis: 'Poids par colis (kg)',
  },
  filtre: {
    dateExpedition: 'Date d\'expédition',
    nomDestination: 'Nom du destinataire',
  },
  onglet: {
    expedition: 'Expédition',
    bonExpedition: 'Bon d\'expédition',
  },
  breadcrumb: {
    liste: 'Liste des bons d\'expédition',
  },
};
